export default function TrustBadges() {
  const badges = [
    { text: 'Updated Daily', icon: 'ri-refresh-line' },
    { text: 'Beginner Friendly', icon: 'ri-user-heart-line' },
    { text: 'Safe Shopping Guides', icon: 'ri-shield-check-line' },
    { text: 'Category-Based Collections', icon: 'ri-stack-line' },
  ];

  return (
    <section className="w-full bg-background-100/70 border-y border-background-200/60">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-background-200/60">
          {badges.map((badge, idx) => (
            <div
              key={idx}
              className="flex items-center justify-center gap-3 py-5 px-4"
            >
              <div className="w-8 h-8 flex items-center justify-center text-primary-500">
                <i className={`${badge.icon} text-lg`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}